module.exports = __webpack_public_path__ + "static/media/img_pivot.b80c3e0b.PNG";